import { defineMigrations } from '@tldraw/tldraw'

export const Versions = {
  AddReplaceableProps: 1,
  AddIsEditableProp: 2,
  AddIsAutoUpdatableProp: 3,
} as const

export const maskShapeMigrations = defineMigrations({
  currentVersion: Versions.AddIsAutoUpdatableProp,
  migrators: {
    [Versions.AddReplaceableProps]: {
      up: (shape) => {
        return { ...shape, props: { ...shape.props, isReplaceable: false, wasReplaced: false } }
      },
      down: (shape) => {
        const { isReplaceable: _, wasReplaced: __, ...props } = shape.props
        return { ...shape, props }
      },
    },
    [Versions.AddIsEditableProp]: {
      up: (shape) => {
        return { ...shape, props: { ...shape.props, isEditable: true } }
      },
      down: (shape) => {
        const { isEditable: _, ...props } = shape.props
        return { ...shape, props }
      },
    },
    [Versions.AddIsAutoUpdatableProp]: {
      up: (shape) => {
        return { ...shape, props: { ...shape.props, isAutoUpdatable: true } }
      },
      down: (shape) => {
        const { isAutoUpdatable: _, ...props } = shape.props
        return { ...shape, props }
      },
    },
  },
})
